import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AssignmentDisplayStatusV2, AssignmentMetadata, AssignmentType, ConfigType, ExaminationAssignment, ExaminationTermsAndConditions, FormReleaseInfo, PracticeAssignment, PublishScoreInformation, ScoreVisibilityType, SecurityOption, SecurityOptionType, UnixTimestamp } from '../../core';
import { BadInputError, Result, mappingResultError } from '@digibricks/core';
import { Injectable } from '@nestjs/common';
export var AssignmentMapper = (_dec = Injectable(), _dec(_class = /*#__PURE__*/function () {
  function AssignmentMapper() {
    _classCallCheck(this, AssignmentMapper);
  }

  _createClass(AssignmentMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var password = dto.password,
          formReleaseInformation = dto.formReleaseInformation,
          hasPassword = dto.hasPassword,
          type = dto.type,
          systemStatus = dto.systemStatus,
          metadata = dto.metadata;
      var typeOrError = ConfigType.create({
        id: type.id,
        name: type.name
      });

      if (typeOrError.isFailure) {
        return Result.fail(typeOrError.error);
      }

      var systemStatusOrError = ConfigType.create({
        id: systemStatus.id,
        name: systemStatus.name
      });

      if (systemStatusOrError.isFailure) {
        return Result.fail(systemStatusOrError.error);
      }

      var formReleaseInformationOrError = FormReleaseInfo.create({
        id: formReleaseInformation.id,
        version: formReleaseInformation.version,
        formId: formReleaseInformation.formId,
        totalScore: formReleaseInformation.totalScore,
        totalQuestions: formReleaseInformation.totalQuestions
      });

      var baseProps = _objectSpread(_objectSpread({}, dto), {}, {
        formReleaseInformation: formReleaseInformationOrError.getValue(),
        type: typeOrError.getValue(),
        systemStatus: systemStatusOrError.getValue(),
        metadata: null
      });

      if (metadata) {
        var assignmentMetadataProps = {
          isGradedAllSubmission: metadata.isGradedAllSubmission
        };
        var assignmentMetadataOrError = AssignmentMetadata.create(assignmentMetadataProps);

        if (assignmentMetadataOrError.isFailure) {
          return new BadInputError(assignmentMetadataOrError.error);
        }

        baseProps.metadata = assignmentMetadataOrError.getValue();
      }

      if (password) {
        baseProps.password = password;
      }

      if (hasPassword) {
        baseProps.hasPassword = hasPassword;
      }

      switch (type.id) {
        case AssignmentType.Practice:
          {
            return this.toPracticeAssignmentDomain(baseProps, dto);
          }

        case AssignmentType.Examination:
          {
            return this.toExaminationAssignmentDomain(baseProps, dto);
          }

        default:
          return Result.fail("Unsupported assignment type: ".concat(type.id));
      }
    }
  }, {
    key: "toPracticeAssignmentDomain",
    value: function toPracticeAssignmentDomain(baseProps, dto) {
      var _dto$completedAt;

      var startTime = dto.startTime,
          endTime = dto.endTime;

      var props = _objectSpread(_objectSpread({}, baseProps), {}, {
        displayStatus: AssignmentDisplayStatusV2.getDisplayStatusForExamination(UnixTimestamp.now(), startTime, (_dto$completedAt = dto.completedAt) !== null && _dto$completedAt !== void 0 ? _dto$completedAt : endTime)
      });

      var createdPracticeAssignmentOrError = PracticeAssignment.create(props);

      if (createdPracticeAssignmentOrError.isFailure) {
        return new BadInputError(createdPracticeAssignmentOrError.error);
      }

      return createdPracticeAssignmentOrError;
    }
  }, {
    key: "toExaminationAssignmentDomain",
    value: function toExaminationAssignmentDomain(baseProps, dto) {
      var _publishScoreInformat, _dto$completedAt2;

      var securityOptions = dto.securityOptions,
          maximumFoulsAllowed = dto.maximumFoulsAllowed,
          termsAndConditions = dto.termsAndConditions,
          scoreVisibilityType = dto.scoreVisibilityType,
          startTime = dto.startTime,
          endTime = dto.endTime,
          publishScoreInformation = dto.publishScoreInformation;
      var publishScoreInformationOrError = publishScoreInformation ? PublishScoreInformation.fromJson(publishScoreInformation) : null;

      if (publishScoreInformationOrError !== null && publishScoreInformationOrError !== void 0 && publishScoreInformationOrError.isFailure) {
        return mappingResultError(publishScoreInformationOrError);
      }

      var mappedSecurityOptions = securityOptions.map(function (security) {
        return SecurityOption.create({
          key: security.id === SecurityOptionType.copyPaste ? SecurityOptionType.copyPaste : SecurityOptionType.outOfFocusTab,
          translation: security.translation
        }, security.id).getValue();
      });

      var props = _objectSpread(_objectSpread({}, baseProps), {}, {
        publishScoreInformation: (_publishScoreInformat = publishScoreInformationOrError === null || publishScoreInformationOrError === void 0 ? void 0 : publishScoreInformationOrError.getValue()) !== null && _publishScoreInformat !== void 0 ? _publishScoreInformat : null,
        securityOptions: mappedSecurityOptions,
        maximumFoulsAllowed: maximumFoulsAllowed,
        termsAndConditions: termsAndConditions ? ExaminationTermsAndConditions.create(termsAndConditions).getValue() : undefined,
        scoreVisibilityType: ScoreVisibilityType.create(scoreVisibilityType).getValue(),
        displayStatus: AssignmentDisplayStatusV2.getDisplayStatusForExamination(UnixTimestamp.now(), startTime, (_dto$completedAt2 = dto.completedAt) !== null && _dto$completedAt2 !== void 0 ? _dto$completedAt2 : endTime, scoreVisibilityType, publishScoreInformation != null)
      });

      var createdExaminationAssignmentOrError = ExaminationAssignment.create(props);

      if (createdExaminationAssignmentOrError.isFailure) {
        return new BadInputError(createdExaminationAssignmentOrError.error);
      }

      return createdExaminationAssignmentOrError;
    }
  }]);

  return AssignmentMapper;
}()) || _class);